
import { RHFTextField } from '@/commons/hook-form';
import { Iconic } from '@/commons/iconic';
import { Button } from '@PorkyCol/button';
import { useState } from 'react';
import { UseFormUnregister } from 'react-hook-form';
import { GenerateElectornicBillForm } from '../bill-electronic';

export const EmailList = ({ unregister }: { unregister: UseFormUnregister<GenerateElectornicBillForm>}) => {
  const [emailList, setEmailList] = useState<{ id: number, value: string}[]>([]);

  const addField = () => {
    const newId = emailList.length ? emailList[emailList.length - 1].id + 1 : 0;
    setEmailList([...emailList, { id: newId, value: '' }])
  };

  const removeField = (id: number) => {
    setEmailList(emailList.filter(field => field.id !== id))
    unregister(`email_cc_list.${id}`);
  };

  return (
    <>
      <div className="flex my-2 justify-end">
        <Button
          color="primary"
          type="button"
          variant="ghost"
          onClick={addField}
        >
          Enviar a otro email
        </Button>
      </div>
      <div className="flex flex-col gap-2 py-4">
        {emailList.map((email, index) => (
            <div className='flex items-center gap-1'>
              <RHFTextField
                key={email.id}
                name={`email_cc_list[${email.id}]`}
                size="medium"
                label="Correo electrónico"
                type="email"
                fullWidth
                defaultValue={email.value}
              />
              <Iconic icon="eva:close-fill" onClick={() => removeField(email.id)} />
            </div>
        ))}
      </div>
    </>
  );
};
